import { useEffect } from 'react';

// Calls loadMore when the sentinel ref scrolls into view. Shared by the desktop
// table and the mobile card list.
export default function useInfiniteScroll(sentinelRef, { hasMore, loading, loadMore }) {
  useEffect(() => {
    if (!hasMore || !sentinelRef.current) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading) loadMore();
    }, { rootMargin: '400px' });
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [sentinelRef, hasMore, loading, loadMore]);
}
